import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getEffectiveConsent, setStoredConsent, type ConsentState } from '../analytics/consent';
import { setConsent } from '../analytics/analytics';

const Banner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(20, 20, 20, 0.98);
  color: white;
  padding: 16px;
  z-index: 3000;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.3);
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 100vw;
  margin: 0 auto;
  width: 100%;
  flex-wrap: wrap;
`;

const Buttons = styled.div`
  display: flex;
  gap: 4px;
  width: auto;
  align-items: center;
`;

const Btn = styled.button<{variant?: 'primary' | 'secondary'}>`
  padding: 4px 10px;
  border-radius: 8px;
  border: 2px solid ${p => p.variant === 'secondary' ? '#888' : 'transparent'};
  background: ${p => p.variant === 'secondary' ? 'transparent' : '#ec5c2c'};
  color: ${p => p.variant === 'secondary' ? 'white' : 'white'};
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  min-width: 80px;
`;

const Text = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.3;
  opacity: 0.95;
  text-align: left;
  width: auto;
  flex: 1 1 300px;
  min-width: 200px;
`;

const ConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const eff = getEffectiveConsent();
    if (eff === 'unknown') setVisible(true);
    setConsent(eff);
  }, []);

  const choose = (state: Exclude<ConsentState, 'unknown'>) => {
    setStoredConsent(state);
    setConsent(state);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <Banner role="dialog" aria-live="polite">
      <Content>
        <Text>
          {t('consent.bannerText', {
            defaultValue:
              'We use privacy-friendly analytics to understand visits, performance, and form usage. We do not collect personal data. You can change your choice anytime in your browser storage.'
          })}
        </Text>
        <Buttons>
          <Btn variant="secondary" onClick={() => choose('denied')}>
            {t('consent.decline', { defaultValue: 'Decline' })}
          </Btn>
          <Btn onClick={() => choose('granted')}>
            {t('consent.allow', { defaultValue: 'Allow analytics' })}
          </Btn>
        </Buttons>
      </Content>
    </Banner>
  );
};

export default ConsentBanner;
